// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // API_END_POINT: 'http://localhost:3011',
    API_END_POINT: 'https://sr-backend-api.takeleap.in/',//QA backend API  point
    IMS_API_END_POINT: 'https://ims.seekright.com/',//QA backend API  point
    AUDIT_API_END_POINT: 'https://sr-audit.takeleap.in/',//QA node backend API  point
    // API_END_POINT: 'https://sr-prod-python.seekright.com/',//QA backend API  point
    // API_END_POINT: 'https://python.seekright.com/',
    mapBoxApiKey: 'pk.eyJ1IjoicmF2aXRhYWRpMiIsImEiOiJjbTY4emdwZHcwNjVvMmpzZTE5MmY4cmZ6In0.foHg5a0_rCynxXDq0xJG-g',
    ANTON_BASE_URL_VIDEOS: 'https://auditor-master-images.seekright.com/SeekRight/',
    AWS_S3_BASE_URL_IMAGES: 'https://tlviz.s3.ap-south-1.amazonaws.com/SeekRight/',
    googleClientId:'830534473071-ob4isnr4rpvela6djsuq0cb2acia3m31.apps.googleusercontent.com',
    mapBoxStyleUrl:'mapbox://styles/mapbox/streets-v11'
    //marker changed to icon and map changed to satellite view,should be uncommented
    // mapBoxStyleForStreetUrl:'mapbox://styles/mapbox/streets-v11',
    //marker changed to icon and map changed to satellite view,should be uncommented
    // mapBoxStyleForSatelliteUrl:'mapbox://styles/mapbox/satellite-v9'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
